export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "SEARCH_COMPANY_PLACEHOLDER": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Search for ", _interpolate(_named("company"))])},
        "CURRENT_COMPANY": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Current ", _interpolate(_named("company"))])},
        "FROM_DIRECTORY": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Found in ", _interpolate(_named("database"))])},
        "NOT_FOUND": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No companies were found."])},
        "COMPANIES_FOUND": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Companies found"])},
        "NEW_COMPANY_HINT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select to create"])},
        "COMPANY_NAME_VALIDATION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company name is mandatory."])},
        "IN_THIS_BRIEF": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Already evaluated in this ", _interpolate(_named("brief"))])}
      }
    }
  })
}
